import { render, staticRenderFns } from "./wikiWriter.vue?vue&type=template&id=1956c50a&"
import script from "./wikiWriter.vue?vue&type=script&lang=js&"
export * from "./wikiWriter.vue?vue&type=script&lang=js&"
import style0 from "./wikiWriter.vue?vue&type=style&index=0&id=1956c50a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports